import { SerializedConstructor } from '@langchain/core/load/serializable';

import { getPromptManifest } from '@/Pages/Playground/utils/Playground.utils';

import { ManifestHubProps } from '../Manifest.utils';
import { useManifestMap } from './ManifestConstructorMap';

export function ManifestHub(props: ManifestHubProps<SerializedConstructor>) {
  const promptManifest = getPromptManifest(props.value);
  const manifestMap = useManifestMap();
  const specificEntry = manifestMap[promptManifest.id.join('/')];

  const ManifestSpecificHub = specificEntry?.hub;

  if (ManifestSpecificHub) {
    return <ManifestSpecificHub {...props} />;
  }

  return null;
}
